export function captcha() {
	if (document.querySelector(".grecaptcha-badge")) {
		initCaptchaClass();
	}

	const observer = new MutationObserver(() => {
		if (document.querySelector(".grecaptcha-badge")) {
			initCaptchaClass();
			observer.disconnect();
		}
	});

	observer.observe(document, {
		childList: true,
		subtree: true,
	});

	function initCaptchaClass() {
		const captchaClass = "with-captcha-badge";
		if (!document.documentElement.classList.contains(captchaClass)) {
			document.documentElement.classList.add(captchaClass);
		}
	}
}
